<template>
  <div style="width:100%;float:left;margin-top:80px;">
    <v-footer :padless="true" absolute>
      <v-card flat tile width="100%" class="lighten-1 text-center" color="#1E242E">
        <v-card-text>
          <v-btn v-for="icon in icons" :key="icon" class="mx-4" icon>
            <v-icon size="24px" color="#B6C1CB">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} —
          <strong>tradeinpool.com</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      icons: ["home", "mail", "event", "delete"],
      items: ["default", "absolute", "fixed"],
      padless: true,
      variant: "default"
    };
  },
  computed: {
    localAttrs() {
      const attrs = {};

      if (this.variant === "default") {
        attrs.absolute = false;
        attrs.fixed = false;
      } else {
        attrs[this.variant] = true;
      }
      return attrs;
    }
  }
};
</script>
<style scoped>
</style>
